import { lazy } from 'react'
import ComparisonData from './ComparisonData'
import DashboardData from './DashboardData'
import InformasiDanBantuan from './InformasiDanBantuan'
import Reports from './Reports'
import TaskManagement from "./TaskManagement"
import Percakapan from "./Percakapan"
import Auth from './Auth'
import Hukdis from './Hukdis'
import RegisterDoc from './RegisterDoc'
import Organization from './Organization'
import Archive from './Archive'
import ManajemenLaporan from './ManajemenLaporan'
import Settings from './Settings'
import ApiGate from './ApiGateway'
import Keamanan from './Keamanan'
import Profile from './Profile'
import SKK from './SKK'

// ** Document title
const TemplateTitle = '%s - Vuexy React Admin Template'

// ** Default Route
const DefaultRoute = '/dashboard'

// ** Merge Routes
const Routes = [
  ...SKK,
  ...ManajemenLaporan,
  ...Settings,
  ...Archive,
  ...Auth,
  ...ComparisonData,
  ...DashboardData,
  ...Reports,
  ...TaskManagement,
  ...InformasiDanBantuan,
  ...Percakapan,
  ...Hukdis,
  ...RegisterDoc,
  ...Organization,
  ...ApiGate,
  ...Keamanan,
  ...Profile
]

export { DefaultRoute, TemplateTitle, Routes }
